import React from 'react';
import Svg, {Path} from 'react-native-svg';

type IconProps = {
  width?: number;
  height?: number;
  color?: string;
};

const CCTicketIcon: React.FC<IconProps> = ({
  width = 10,
  height = 10,
  color = '#4D3F37',
}) => {
  return (
    <Svg width={width} height={height} viewBox="0 0 10 10" fill="none">
      <Path
        d="M4.16671 3.33335V2.91669M4.16671 5.20835V4.79169M4.16671 7.08335V6.66669M2.16671 1.66669H7.83337C8.30008 1.66669 8.53344 1.66669 8.7117 1.75751C8.8685 1.83741 8.99599 1.96489 9.07588 2.12169C9.16671 2.29995 9.16671 2.53331 9.16671 3.00002V3.54169C8.36129 3.54169 7.70837 4.19461 7.70837 5.00002C7.70837 5.80544 8.36129 6.45835 9.16671 6.45835V7.00002C9.16671 7.46673 9.16671 7.70009 9.07588 7.87835C8.99599 8.03515 8.8685 8.16263 8.7117 8.24253C8.53344 8.33335 8.30008 8.33335 7.83337 8.33335H2.16671C1.7 8.33335 1.46664 8.33335 1.28838 8.24253C1.13158 8.16263 1.0041 8.03515 0.924202 7.87835C0.833374 7.70009 0.833374 7.46673 0.833374 7.00002V6.45835C1.63879 6.45835 2.29171 5.80544 2.29171 5.00002C2.29171 4.19461 1.63879 3.54169 0.833374 3.54169V3.00002C0.833374 2.53331 0.833374 2.29995 0.924202 2.12169C1.0041 1.96489 1.13158 1.83741 1.28838 1.75751C1.46664 1.66669 1.7 1.66669 2.16671 1.66669Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};

export default CCTicketIcon;
